import { Panel, PanelHeaderTemplateOptions } from "primereact/panel";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";

import { formatDate } from "../../../../utils/format";
import { Gps391Props } from "./types";
import { useTranslation } from "react-i18next";
import NadaConsta from "../../../../components/nadaConsta";



export function Gps391({ data }: Gps391Props) {
  const { t } = useTranslation();
  const headerTemplate = (options: PanelHeaderTemplateOptions) => {
    const className = `${options.className} `;
    return  <div className={className}> {data["SPCA-124-DEBITO"] && data["SPCA-124-DEBITO"].length > 0 ? (<div><span style={{color:'#C70039'}} className="pi-consulta pi pi-exclamation-triangle"></span><span className="p-panel-title" style={{marginLeft:'1rem', fontFamily: 'var(--font-family)', color:'black'}}>{t('restricaoMercado')}</span></div>) : (<span className="p-panel-title" style={{marginLeft:'1rem', fontFamily: 'var(--font-family)', color:'black'}}>{t('restricaoMercado')}</span>) }</div>;
  }

  return (
        <Panel headerTemplate={headerTemplate}>
          {data["SPCA-124-DEBITO"].length === 0 ? ( <NadaConsta />) : (
          <DataTable value={data["SPCA-124-DEBITO"]} scrollable className="no-wrap-table">
            <Column field="SPCA-124-UF" header="UF" />
            <Column field="SPCA-124-MOEDA" header="Moeda" />
            <Column field="SPCA-124-VALORN" header="Valor" />
            <Column field="SPCA-124-SITUACAO" header="Situação" />
            <Column field="SPCA-124-TIPO" header="Tipo" />
            <Column field="SPCA-124-CIDADE" header="Cidade" />
            <Column field="SPCA-124-CONDICAO" header="Condição" />
            <Column field="SPCA-124-VALOR" header="Valor" />
            <Column field="SPCA-124-INFORMANTE" header="Informante" />
            <Column field="SPCA-124-DESCRICAO" header="Descrição" />
            <Column field="SPCA-124-CONTRATO" header="Contrato" />
            <Column
              field="SPCA-124-DATA"
              header="Data Registro"
              body={(rowData) => formatDate(rowData["SPCA-124-DATA"]["SPCA-124-REGISTRO"])}
            />
            <Column
              field="SPCA-124-DATA"
              header="Data Disponível"
              body={(rowData) => formatDate(rowData["SPCA-124-DATA"]["SPCA-124-REGISTRO"])}
            />
          </DataTable>)}
        </Panel>
  );
}
